function initSwiper(container) {
  // Se o container não for especificado, usa o documento inteiro.
  const scope = container || document;

  // Encontra todos os carrosséis dentro do escopo que ainda não foram inicializados.
  const swiperElements = scope.querySelectorAll('.swiper-container-to-init:not(.swiper-initialized)');

  if (swiperElements.length === 0) return;

  swiperElements.forEach(element => {
    if (typeof Swiper === 'undefined') {
      console.error('A biblioteca Swiper.js não foi encontrada.');
      return;
    }

    let userOptions = {};
    const optionsAttribute = element.dataset.swiperOptions;
    if (optionsAttribute) {
      try {
        userOptions = JSON.parse(optionsAttribute);
      } catch (e) {
        console.error('Erro ao ler as opções JSON do Swiper:', e, element);
      }
    }

    let finalOptions = { ...userOptions };

    const paginationEl = element.querySelector('.swiper-pagination');
    if (paginationEl && userOptions.pagination !== false) {
      finalOptions.pagination = {
        el: paginationEl,
        clickable: true,
        ...userOptions.pagination
      };
    }

    const nextEl = element.querySelector('.swiper-button-next');
    const prevEl = element.querySelector('.swiper-button-prev');
    if (nextEl && prevEl && userOptions.navigation !== false) {
      finalOptions.navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
        ...userOptions.navigation
      };
    }

    // Lógica para a barra de rolagem
    const scrollbarEl = element.querySelector('.swiper-scrollbar');
    if (scrollbarEl && userOptions.scrollbar !== false) {
      finalOptions.scrollbar = {
        el: scrollbarEl,
        draggable: true,
        // ADIÇÃO: Impede que a barra "pule" para a posição do clique.
        // Apenas o arraste direto no "handle" funcionará.
        dragOnly: true, 
        ...userOptions.scrollbar
      };
    }

    new Swiper(element, finalOptions);
    // Adiciona uma classe para marcar como inicializado e evitar reinicialização.
    element.classList.add('swiper-initialized');
  });
}

// Event listeners que rodam apenas uma vez.
document.addEventListener('DOMContentLoaded', () => initSwiper());

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    // Inicializa o Swiper apenas na nova seção que foi carregada.
    initSwiper(event.target);
  });
}